import { AxiosError } from 'axios';
import Bugsnag from '@bugsnag/js';
import Errlop from 'errlop';

export class Logger {
  /**
   * Provides Bugsnag with the given error message and details from the Axios error.
   */
  static axiosError(errorMessage: string, axiosError: AxiosError) {
    Logger.error(
      `${errorMessage}: ${<string>(<unknown>axiosError.response?.status)} ${<string>axiosError.response?.data}`,
      axiosError
    );
  }

  /**
   * Provides Bugsnag with the given error message an an optional parent Error
   * if provided.
   */
  static error(errorMessage: string, errorParent?: Error | Errlop) {
    const errorStack = new Errlop(errorMessage, errorParent).stack;
    Bugsnag.notify(errorStack);
  }

  /**
   * Provides Bugsnag with the given message at an "info" severity.
   */
  static info(message: string) {
    Bugsnag.notify(message, (event) => {
      event.severity = 'info';
    });
  }
}

export default function useLogger() {
  return {
    axiosError: (errorMessage: string, axiosError: AxiosError) => Logger.axiosError(errorMessage, axiosError),
    error: (errorMessage: string, errorParent?: Error | Errlop) => Logger.error(errorMessage, errorParent),
    info: (message: string) => Logger.info(message),
  };
}
